export const obfOptionsFilterStructure = [
    {
        property: 'postcode',
        allProperty: [
            { selector: 'postCode', dep: true },
            { selector: 'postcode', dep: false },
        ],
        reset: true
    },
    {
        property: 'address_line_one',
        allProperty: [
            { selector: 'address_line_one', dep: false },
        ],
        reset: true
    },
    {
        property: 'address_line_two',
        allProperty: [
            { selector: 'address_line_two', dep: false },
        ],
        reset: true
    },
    {
        property: 'api_url',
        type: 'string',
        allProperty: [
            { selector: 'api_url', dep: false },
        ],
        reset: false
    },
    {
        property: 'app_url',
        type: 'string',
        allProperty: [
            { selector: 'appUrl', dep: true },
            { selector: 'app_url', dep: false },
        ],
        reset: false
    },
    {
        property: 'logo_url',
        allProperty: [
            { selector: 'logoUrl', dep: true },
            { selector: 'logo_url', dep: false },
        ],
        reset: false
    },
    {
        property: 'free_quote',
        allProperty: [
            { selector: 'freeQuote', dep: true },
            { selector: 'free_quote', dep: false },
        ],
        reset: false
    },
    {
        property: 'action',
        allProperty: [
            { selector: 'bookingEditType', dep: true },
            { selector: 'booking_edit_type', dep: true },
            { selector: 'action', dep: false },
        ],
        valueChange: [
            { old: 'serviceChoices', new: 'edit' },
            { old: 'serviceAvailability', new: 'reschedule' },
            { old: 'serviceRebook', new: 'rebook' },
            { old: 'reschedule', new: 'reschedule' },
            { old: 'edit', new: 'edit' },
        ],
        reset: true
    },
    {
        property: 'booking_id',
        allProperty: [
            { selector: 'bookingId', dep: true },
            { selector: 'booking_id', dep: false },
        ],
        reset: true
    },
    {
        property: 'default_category_id',
        allProperty: [
            { selector: 'defaultCategoryId', dep: true },
            { selector: 'defaultServiceCategoryId', dep: true },
            { selector: 'default_category_id', dep: false }
        ],
        type: 'number',
        reset: false
    },
    {
        property: 'default_service_id',
        type: 'number',
        allProperty: [
            { selector: 'defaultServiceId', dep: true },
            { selector: 'defaultServiceTypeId', dep: true },
            { selector: 'default_service_id', dep: false }
        ],
        reset: true
    },
    {
        property: 'default_category_title',
        type: 'string',
        allProperty: [
            { selector: 'defaultCategoryType', dep: true },
            { selector: 'default_category_title', dep: false },
        ],
        reset: false
    },
    {
        property: 'default_service_title',
        type: 'string',
        allProperty: [
            { selector: 'defaultServiceType', dep: true },
            { selector: 'default_service_title', dep: false },
        ],
        reset: false
    },
    {
        property: 'hide_phone',
        allProperty: [
            { selector: 'showPhone', dep: true },
            { selector: 'hide_phone', dep: false },
        ],
        reset: false
    },
    {
        property: 'phone',
        allProperty: [
            { selector: 'phone', dep: false },
        ],
        reset: false
    },
    {
        property: 'lang',
        allProperty: [
            { selector: 'lang', dep: false },
        ],
        reset: false
    },
    {
        property: 'campaign_abbr',
        allProperty: [
            { selector: 'campaign_abbr', dep: false },
        ],
        reset: false
    },
    {
        property: 'campaign_id',
        allProperty: [
            { selector: 'campaign_id', dep: false },
        ],
        reset: false
    },
    {
        property: 'exit_position',
        allProperty: [
            { selector: 'exit_position', dep: false },
        ],
        reset: false
    },
    {
        property: 'address_id',
        allProperty: [
            { selector: 'address_id', dep: false },
            { selector: 'addressId', dep: true },
        ],
        reset: false
    },
    {
        property: 'main_url',
        allProperty: [
            { selector: 'mainUrl', dep: true },
            { selector: 'main_url', dep: false },
        ],
        reset: false
    },
    {
        property: 'domain_url',
        allProperty: [
            { selector: 'domain_url', dep: false },
        ],
        reset: false
    },
    {
        property: 'website_name',
        allProperty: [
            { selector: 'websiteName', dep: true },
            { selector: 'website_name', dep: false },
        ],
        reset: false
    },
    {
        property: 'profile_id',
        allProperty: [
            { selector: 'profileID', dep: true },
            { selector: 'profile_id', dep: false },
        ],
        reset: false
    },
    {
        property: 'profile',
        allProperty: [
            { selector: 'profile', dep: false },
        ],
        reset: false
    },
    {
        property: 'source_abbr',
        allProperty: [
            { selector: 'sourceAbbr', dep: true },
            { selector: 'source_abbr', dep: false },
        ],
        reset: false
    },
    {
        property: 'fs_payload',
        allProperty: [
            { selector: 'fs_payload', dep: false },
        ],
        reset: true
    },
    {
        property: 'utp',
        allProperty: [
            { selector: 'utp', dep: false },
        ],
        reset: true
    },
    {
        property: 'fs_item_prefill',
        allProperty: [
            { selector: 'fs_item_prefill', dep: false },
        ],
        reset: true
    },
    {
        property: 'theme',
        allProperty: [
            { selector: 'theme', dep: false },
        ],
        childrenPropertys: [
            {
                property: 'accent-color-darker',
                allProperty: [
                    { selector: 'accent-color-darker', dep: false },
                ]
            },
            {
                property: 'accent-color-dark',
                allProperty: [
                    { selector: 'accent-color-dark', dep: false },
                ]
            },
            {
                property: 'accent-color',
                allProperty: [
                    { selector: 'accent-color', dep: false },
                ]
            },
            {
                property: 'accent-color-light',
                allProperty: [
                    { selector: 'accent-color-light', dep: false },
                ]
            },
            {
                property: 'accent-color-lighter',
                allProperty: [
                    { selector: 'accent-color-lighter', dep: false },
                ]
            },
            {
                property: 'primary-color-darker',
                allProperty: [
                    { selector: 'primary-color-darker', dep: false },
                ]
            },
            {
                property: 'primary-color-dark',
                allProperty: [
                    { selector: 'primary-color-dark', dep: false },
                ]
            },
            {
                property: 'primary-color',
                allProperty: [
                    { selector: 'primary-color', dep: false },
                ]
            },
            {
                property: 'primary-color-light',
                allProperty: [
                    { selector: 'primary-color-light', dep: false },
                ]
            },
            {
                property: 'primary-color-lighter',
                allProperty: [
                    { selector: 'primary-color-lighter', dep: false },
                ]
            },
            {
                property: 'secondary-color-darker',
                allProperty: [
                    { selector: 'secondary-color-darker', dep: false },
                ]
            },
            {
                property: 'secondary-color-dark',
                allProperty: [
                    { selector: 'secondary-color-dark', dep: false },
                ]
            },
            {
                property: 'secondary-color',
                allProperty: [
                    { selector: 'secondary-color', dep: false },
                ]
            },
            {
                property: 'secondary-color-light',
                allProperty: [
                    { selector: 'secondary-color-light', dep: false },
                ]
            },
            {
                property: 'secondary-color-lighter',
                allProperty: [
                    { selector: 'secondary-color-lighter', dep: false },
                ]
            },
            {
                property: 'loader-outside-circle',
                allProperty: [
                    { selector: 'loader-outside-circle', dep: false },
                ]
            },
            {
                property: 'loader-middle-circle',
                allProperty: [
                    { selector: 'loader-middle-circle', dep: false },
                ]
            },
            {
                property: 'loader-inside-circle',
                allProperty: [
                    { selector: 'loader-inside-circle', dep: false },
                ]
            },
        ]
    },
    {
        property: 'gtm_custom_data',
        allProperty: [
            { selector: 'gtmCustomData', dep: true },
            { selector: 'gtm_custom_data', dep: false },
        ],
        reset: false
    },
    {
        property: 'gtm_cid',
        allProperty: [
            { selector: 'gtmCid', dep: true },
            { selector: 'gtm_cid', dep: false },
        ],
        reset: false
    },
    {
        property: 'search',
        allProperty: [
            { selector: 'search', dep: false }
        ],
        reset: false
    },
    {
        property: 'covering_postcode',
        allProperty: [
            { selector: 'covering_postcode', dep: false },
        ],
        reset: false
    },
    {
        property: 'regular_plan_id',
        allProperty: [
            { selector: 'regular_plan_id', dep: false },
        ],
        reset: false
    },
    {
        property: 'screen',
        allProperty: [
            { selector: 'fs_screen', dep: false },
            { selector: 'screen', dep: false },
        ],
        reset: false
    },
    {
        property: 'element_id',
        allProperty: [
            { selector: 'fs_element_id', dep: false },
            { selector: 'element_id', dep: false },
        ],
        reset: false
    },
    {
        property: 'action',
        allProperty: [
            { selector: 'fs_action', dep: false },
            { selector: 'action', dep: false },
        ],
        reset: false
    },
    {
        property: 'key',
        allProperty: [
            { selector: 'key', dep: false },
        ],
        reset: false
    },
    {
        property: 'init_event',
        allProperty: [
            { selector: 'init_event', dep: false },
        ],
        reset: false
    },
    {
        property: 'country',
        allProperty: [
            { selector: 'country', dep: false },
        ],
        reset: false
    },
    {
        property: 'accounts_url',
        allProperty: [
            { selector: 'accountsUrl', dep: true },
            { selector: 'accounts_url', dep: false },
        ]
    },
    {
        property: 'app_url',
        allProperty: [
            { selector: 'appUrl', dep: true },
            { selector: 'app_url', dep: false },
        ],
        reset: false
    },
    {
        property: 'voucher',
        allProperty: [
            { selector: 'promo_code', dep: true },
            { selector: 'promocode', dep: true },
            { selector: 'voucher', dep: false },
        ],
        reset: false
    }
];
